import dimensions from 'shared/styles/dimensions'
import styled, { css } from 'styled-components'

import { colors } from '../../styles/colors'
import Button from '../Button'

export const Container = styled.table`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
`

export const TableRow = styled.tr`
  background-color: ${colors.white};
  color: ${({ color }) => color ?? `${colors.grayDark}`};
  text-align: center;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 44px;
  width: 100%;
  margin: ${dimensions.spaces.small}px 0;

  &:last-child {
    border-radius: 0 0 4px 4px;
  }

  border-bottom: 1px solid ${colors.grayExtraLight};
`

export const TableHead = styled.tr`
  color: ${colors.gray7};
  font-size: 12px;
  font-weight: 700;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 10px 20px;
`

export const THead = styled.thead`
  background-color: ${colors.grayLight4};
  height: 44px;
  border-radius: 4px 4px 0 0;
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`

export const TBody = styled.tbody`
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`

export const TableItem = styled.td<{ active?: boolean; scroll?: boolean }>`
  display: flex;
  color: ${({ active }) => (active ? `${colors.green}` : `${colors.grayDark}`)};
  flex-direction: row;
  font-size: 14px;
  height: 100%;
  align-items: center;
  justify-content: flex-start;
  font-weight: 500;
  width: 100%;
  flex: 1;

  padding: 10px 20px;

  overflow-y: ${({ scroll }) => (scroll ? `scroll` : `hidden`)};
  overflow-x: hidden;
`

export const IconButtonStyle = styled(Button)`
  color: ${colors.blue};
  width: 40px;
  height: 40px;
`
interface IStatusProps {
  status: string
}
export const StatusComprovante = styled.div<IStatusProps>`
  width: 8px;
  height: 8px;
  border-radius: 4px;
  margin: 0px 4px;

  ${props =>
    props.status === 'Disponível' &&
    css`
      background-color: ${colors.green};
    `}

  ${props =>
    props.status === 'Processando' &&
    css`
      background-color: ${colors.warning};
    `}

  ${props =>
    props.status === 'Indisponível' &&
    css`
      background-color: ${colors.red};
    `}
`
